import { useCallback, useMemo } from 'react';
import { batch, useDispatch } from 'react-redux';
import {
  isAnalysisLoadingSelector,
  isAnalysisRefreshedSelector,
} from '../../redux/selectors/loadingAnalyses';
import { clearAnalysisAction } from '../../redux/slices/analyses';
import { setLoadingAnalysesInStoreAction } from '../../redux/slices/loadingAnalyses';
import { isAnalysisLoadedSelector } from '../../redux/selectors/analyses';
import { useAppSelector } from '../../redux/hooks';

export default (analysisId: string) => {
  const dispatch = useDispatch();

  const isAnalysisLoadingMemoSelector = useMemo(isAnalysisLoadingSelector, []);
  const isAnalysisRefreshedMemoSelector = useMemo(
    isAnalysisRefreshedSelector,
    [],
  );
  const isAnalysisLoadedMemoSelector = useMemo(isAnalysisLoadedSelector, []);

  const isAnalysisLoading = useAppSelector((state) =>
    isAnalysisLoadingMemoSelector(state, analysisId),
  );
  const isAnalysisRefreshed = useAppSelector((state) =>
    isAnalysisRefreshedMemoSelector(state, analysisId),
  );
  const isAnalysisLoaded = useAppSelector((state) =>
    isAnalysisLoadedMemoSelector(state, analysisId),
  );

  const handleLoadAnalysisInStore = useCallback(
    (refresh?: boolean) => {
      batch(() => {
        dispatch(clearAnalysisAction(analysisId));
        dispatch(
          setLoadingAnalysesInStoreAction({
            analysisIds: [analysisId],
            refresh: !!refresh,
          }),
        );
      });
    },
    [dispatch, analysisId],
  );

  return {
    isAnalysisLoading,
    isAnalysisRefreshed,
    handleLoadAnalysisInStore,
    isAnalysisLoaded,
  };
};
